module.exports = __webpack_public_path__ + "img/answer-pin.d57a8aab.svg";